import React, { FC } from 'react';
import PostComposerContentText from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentText';
import { PostComposerContentProps } from 'app/modules/posts/modules/post/components/composer/PostComposerContent';
import PostComposerContentMediaAttachments from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentMediaAttachemnts';
import { PseudoPostType } from 'constants/post';
import PostComposerContentFirstComment from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentFirstComment';
import PostsConfig from 'app/config/posts';
import PostComposerContentLinkAppender from 'app/modules/posts/modules/post/components/composer/postComposerContent/PostComposerContentLinkAppender';

type Props = PostComposerContentProps;

const PostComposerContentTwitter: FC<Props> = ({
  value,
  onChange,
  onTextEditorInit,
  onTranslationEditorInit,
  swapTextTranslation,
}) => {
  const pseudoType = value.pseudoType;

  return (
    <>
      <PostComposerContentText
        value={value}
        onChange={onChange}
        onTextEditorInit={onTextEditorInit}
        onTranslationEditorInit={onTranslationEditorInit}
        swapTextTranslation={swapTextTranslation}
      />
      <PostComposerContentFirstComment onChange={onChange} value={value} />
      {pseudoType && (
        <>
          {[
            PseudoPostType.Photo,
            PseudoPostType.Video,
            PseudoPostType.Gallery,
            PseudoPostType.PhotoGallery,
          ].includes(pseudoType) && (
            <PostComposerContentMediaAttachments
              value={value}
              onChange={onChange}
              allowedFiles={
                PseudoPostType.Video === pseudoType ? ['video'] : ['image']
              }
              maxCount={
                [PseudoPostType.Photo, PseudoPostType.Video].includes(
                  pseudoType,
                )
                  ? PostsConfig.MIN_FILES_TO_ACCEPT
                  : PostsConfig.MAX_FILES_TO_ACCEPT
              }
            />
          )}
          {[PseudoPostType.Link].includes(pseudoType) && (
            <PostComposerContentLinkAppender
              value={value}
              onChange={onChange}
              withLinkFieldOverride
            />
          )}
        </>
      )}
    </>
  );
};

export default PostComposerContentTwitter;
